import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../../firebase';
import Partners from './Partners';

export default function Footer() {
  const [contactData, setContactData] = useState({
    address: 'Halkalı Merkez Mah. 1. Çeşme Sok. No: 13/E Küçükçekmece / İstanbul',
    phone: '0 532 500 38 69',
    email: 'info@kareyapıinsaat.com',
    facebook: 'https://www.facebook.com/kareyapiinsaat',
    instagram: 'https://www.instagram.com/kamerun_insaat?igsh=MWFqNTkyMmU3eGRlYg%3D%3D',
    twitter: '',

    youtube: 'https://www.youtube.com/kareyapiinsaat'
  });

  useEffect(() => {
    const unsub = onSnapshot(doc(db, 'settings', 'contact'), (document) => {
      if (document.exists()) {
        const data = document.data();
        // Force the new official address immediately to override stale database state
        data.address = 'Halkalı Merkez Mah. 1. Çeşme Sok. No: 13/E Küçükçekmece / İstanbul';
        data.instagram = 'https://www.instagram.com/kamerun_insaat?igsh=MWFqNTkyMmU3eGRlYg%3D%3D';
        setContactData(prev => ({ ...prev, ...data }));
      }
    });
    return () => unsub();
  }, []);

  return (
    <footer className="bg-gray-900 text-white">
      {/* Solution Partners Marquee */}
      <Partners />

      {/* Main Footer */}
      <div className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {/* Company Info */}
            <div>
              <button 
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                className="block mb-6 hover:opacity-80 transition-opacity cursor-pointer focus:outline-none"
              >
                <img
                  src="https://static.readdy.ai/image/462a574349d19c517babfc55bf63e079/c8ac21bc970c8b7e4f4c5b80839b9d5d.png"
                  alt="KARE YAPI İNŞAAT Logo"
                  className="h-20 w-auto object-contain transition-all hover:scale-105 brightness-0 invert opacity-90 hover:opacity-100"
                />
              </button>
              <p className="text-gray-400 text-sm leading-relaxed mb-6">
                KARE YAPI İNŞAAT sizin ve ailenizin yaşam kalitesini yükseltecek özelliklerde projelendirildi. 
                En ince detayına kadar özenle ve kusursuz çözümlenerek size konforlu bir yaşam sunuyor.
              </p>
              <div className="flex flex-wrap gap-3">
                {contactData.facebook && (
                  <a href={contactData.facebook} target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer">
                    <i className="ri-facebook-fill text-lg"></i>
                  </a>
                )}
                {contactData.phone && (
                  <a href={`https://wa.me/90${contactData.phone.replace(/\D/g, '').replace(/^0/, '')}`} target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-green-600 rounded-full transition-colors cursor-pointer">
                    <i className="ri-whatsapp-line text-lg"></i>
                  </a>
                )}
                {contactData.instagram && (
                  <a href={contactData.instagram} target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-lg"></i>
                  </a>
                )}
                {contactData.youtube && (
                  <a href={contactData.youtube} target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer">
                    <i className="ri-youtube-fill text-lg"></i>
                  </a>
                )}
                {contactData.twitter && (
                  <a href={contactData.twitter} target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-gray-800 hover:bg-red-600 rounded-full transition-colors cursor-pointer">
                    <i className="ri-twitter-x-line text-lg"></i>
                  </a>
                )}
              </div>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-xl font-bold mb-6">İletişim Bilgileri</h3>
              <div className="space-y-4 text-gray-400 text-sm">
                <div className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-red-500 text-lg mt-0.5"></i>
                  <span className="leading-relaxed">{contactData.address}</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-phone-line text-red-500 text-lg"></i>
                  <a href={`tel:${contactData.phone.replace(/\s+/g, '')}`} className="hover:text-white transition-colors tracking-widest font-bold">
                    {contactData.phone}
                  </a>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-mail-line text-red-500 text-lg"></i>
                  <a href={`mailto:${contactData.email}`} className="hover:text-white transition-colors">
                    {contactData.email}
                  </a>
                </div>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-xl font-bold mb-6">Hızlı Erişim</h3>
              <div className="grid grid-cols-2 gap-3">
                <div className="space-y-3">
                  <a href="/" className="flex items-center gap-2 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line"></i>
                    <span>Anasayfa</span>
                  </a>
                  <a href="/about" className="flex items-center gap-2 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line"></i>
                    <span>KARE YAPI</span>
                  </a>
                  <a href="/gallery" className="flex items-center gap-2 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line"></i>
                    <span>Galeri</span>
                  </a>
                  <a href="/contact" className="flex items-center gap-2 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line"></i>
                    <span>İletişim</span>
                  </a>
                </div>
                <div className="space-y-3">
                  <a href="/catalog" className="flex items-center gap-2 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line"></i>
                    <span>E-KATALOG</span>
                  </a>
                  <a href="/floor-plans" className="flex items-center gap-2 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line"></i>
                    <span>Kat Planları</span>
                  </a>
                  <a href="/request-form" className="flex items-center gap-2 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line"></i>
                    <span>Konut Talep Formu</span>
                  </a>
                  <a href="/contact" className="flex items-center gap-2 text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line"></i>
                    <span>Mesaj Formu</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-gray-800 py-6">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-gray-400 text-sm tracking-widest font-medium uppercase text-xs">
            KARE YAPI İNŞAAT - Tüm Hakkı Saklıdır © {new Date().getFullYear()}
          </p>
        </div>
      </div>
    </footer>
  );
}